import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7114a42"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-whatsapp" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'WhatsappButton',
  setup(__props) {

const { t } = useI18n();

const whatsappLink =
  "https://wa.me/38975201677?text=" +
  encodeURIComponent(t("components.whatsapp-button.prefilled-message"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: whatsappLink,
    target: "_blank",
    rel: "noopener",
    class: "whatsapp-button d-flex align-items-center justify-content-center",
    "aria-label": _unref(t)('components.whatsapp-button.aria-label')
  }, _hoisted_3, 8, _hoisted_1))
}
}

})